import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import commonLabels from "../../../common/labels/common_en.json";
import html2pdf from "html2pdf.js";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import label from "../../labels/administration_en.json";
import {
  getMainsAdvertisements,
  getYearList,
} from "../../../common/actions/commonActions";
import { getExamslistByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { printrecommendationReport } from "../../actions/administrationActions";
import { SET_RECOMMENDATION_REPORTS } from "../../../common/constants/ActionTypes";


const RecommendationReports = () => {
  // var pdfMake = require("pdfmake/build/pdfmake");
  // var pdfFonts = require("pdfmake/build/vfs_fonts");
  // pdfMake.vfs = pdfFonts.pdfMake.vfs;
  // var htmlToPdfmake = require("html-to-pdfmake");
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  const listing = [
    { id: 1, name: "Category & Subcategory wise Merit List" },
    { id: 2, name: "Post wise Recommendation List" },
    { id: 3, name: "Other reports as required by MPSC" },
  ];

  const reportbyMPSClisting = [
    { id: 1, name: "intNoWise" },
    { id: 2, name: "recoCandidatesIntNo" },
    { id: 3, name: "centerWiseRecoCandidates" },
    { id: 4, name: "intNoWiseWithMeritNo" },
    { id: 5, name: "VacantPosition" },
  ];
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    setReloadItem(!reloadItem);
    dispatch({
      type: SET_RECOMMENDATION_REPORTS,
      payload: [],
    });
    setPrintFlag(true);
  }, []);
  const dispatch = useDispatch();
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [selectedlist, setSelectedList] = useState("");
  const [reporType, setReporType] = useState(false);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [getrecoCandidatesIntNo, setgetrecoCandidatesIntNo] = useState("");
  const [intNoWiseWithMeritNo, setintNoWiseWithMeritNo] = useState("");
  const [centerWiseRecoCandidates, setCenterWiseRecoCandidates] = useState("");
  const [intNoWise, setintNoWise] = useState("");
  const [meritListData, setMeritListData] = useState("");
  const [postWiseRecData, setPostWiseRecData] = useState("");
  let { examList, advertisementList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { listRecommendationReports } = useSelector(
    (state) => state.administrationReducer,
    shallowEqual
  );

  const value = parseInt(
    listRecommendationReports?.interviewNumbers?.length / 5
  );

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);
    dispatch({
      type: SET_RECOMMENDATION_REPORTS,
      payload: [],
    });
    setPrintFlag(true);
    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    setReporType(true);
    setSelectedList("");
    examList.length = 0;
   
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setPrintFlag(true);
    dispatch({
      type: SET_RECOMMENDATION_REPORTS,
      payload: [],
    });
    setReloadItem(!reloadItem);
  };
  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setReporType(true);
    setSelectedList("");
    setPrintFlag(true);
    dispatch({
      type: SET_RECOMMENDATION_REPORTS,
      payload: [],
    });
   
    // selectedValue && dispatch(getQualifyingCandidatesList(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onListReport = (ele) => {
    let selected = ele;
    if (selected == 1) {
      setReporType(true);
      setSelectedList(selected);
      setSaveButtonFlag(true);
      dispatch(
        printrecommendationReport(selectedExam, "meritlist", setPrintFlag)
      );
    }
    if (selected == 2) {
      setReporType(true);
      setSelectedList(selected);
      setSaveButtonFlag(true);
      dispatch(
        printrecommendationReport(
          selectedExam,
          "postwiserecolist",
          setPrintFlag
        )
      );
    } else if (selected == 3) {
      setSelectedList(selected);
      setReporType(true);
      setSaveButtonFlag(true);
      setPrintFlag(true);
      dispatch({
        type: SET_RECOMMENDATION_REPORTS,
        payload: [],
      });
    } else {
      setReporType(false);
      setSelectedList(selected);
      setSaveButtonFlag(true);
      setPrintFlag(true);
      dispatch({
        type: SET_RECOMMENDATION_REPORTS,
        payload: [],
      });
    }
  };

  const onReportByMPSC = (ele) => {
    let selected = ele;
    setSelectedList(selected);
    setSaveButtonFlag(false);
    setPrintFlag(true);
    dispatch({
      type: SET_RECOMMENDATION_REPORTS,
      payload: [],
    });
  };

  const onSubmit = () => {
    // dispatch(getrollNoQualifiedCandidate(selectedAdvert, setPrintFlag,setSaveButtonFlag));
    dispatch(
      printrecommendationReport(selectedExam, selectedlist, setPrintFlag)
    );
    // setPrintFlag(false);
    setReloadItem(!reloadItem);
  };

  // const htmlString =
  //   "<div><h1>Hello, this is an example HTML string!</h1></div>";
  // const pdf = async () => {
  //   const pdfDocGenerator = htmlToPdfmake(
  //     "<div><label>" + htmlString + "</label></div>"
  //   );
  //   const pdfContent = pdfMake.createPdf(pdfDocGenerator).getDataUrl();
  //   var headerContentHtml ='<table data-pdfmake="{&quot;widths&quot;:[&quot;20%&quot;,&quot;80%&quot;]}" style="border: 1px solid black; padding:2px; width:100%;margin:0 auto; margin-bottom:5px;font-size:8px"><tr><td style="border-bottom:none; border-right:none;font-weight:bold;"> Owner:</td><td style="border-left:none;border-bottom:1px solid black"><span style="display: block;  margin-bottom: 0px; ">&nbsp;%Borrower%</span></td></tr><tr><td style="border-top:none;border-right:none;font-weight:bold;"> Property Address: </td><td style="border-left:none;"><span style="display: block;  margin-bottom: 0px; ">&nbsp;%PropertyAddress%</span></td></tr></table>';
  //   var headerContentData = htmlToPdfmake(headerContentHtml, {window:window,tableAutoSize:true,});
  //      let pagemargin ='';
  //      if(headerContentHtml)
  //      {
  //      pagemargin = [ 10, 90, 10, 40 ];
  //      }
  //      else
  //      {
  //       pagemargin = [ 10, 10, 10, 40 ];
  //      }
  //   // Create a download link using html2pdf
  //   var docDefinition = {
  //     pageMargins: pagemargin,
  //     content: [html],
  //     pageSize: "Letter",
  //     pageOrientation: "portrait",
  //     unbreakable: true,
  //     dontBreakRows: true,
  //     pageBreakBefore: function (currentNode) {
  //       return (
  //         currentNode.style &&
  //         currentNode.style.indexOf("pdf-pagebreak-before") > -1
  //       );
  //     },
  //   };
  //   var pdfDoc = pdfMake.createPdf(docDefinition);
  // };

  const printQualifyingListPDF = () => {
    genPdf();
    // pdf();
    setReloadItem(!reloadItem);
  };

  const intNoWise1 = [
    ["Value1_Row1", "Value2_Row1"],
    ["Value1_Row2", "Value2_Row2"],
  ];
  // const genPdf = () => {
  //   const pdfMargin = 20;
  //   const pdf = new jsPDF({
  //     orientation: "p",
  //     unit: "mm",
  //     format: "a4",
  //     margins: {
  //       top: pdfMargin,
  //       bottom: pdfMargin,
  //       left: pdfMargin,
  //       right: pdfMargin,
  //     },
  //   });

  //   // Check if intNoWise is an array
  //   if (!Array.isArray(intNoWise)) {
  //     // Loop through intNoWise to generate tables in the PDF
  //     // intNoWise.forEach((tableData, dindex) => {
  //       pdf.autoTable({
  //         // startY: 110 + dindex * 60,
  //         body:intNoWise,
  //         theme: "grid",
  //         styles: {
  //           valign: "middle",
  //           fontSize: 12,
  //         },
  //         headStyles: {
  //           fillColor: [238, 238, 238],
  //           textColor: [0, 0, 0],
  //           fontStyle: "bold",
  //           cellWidth: "wrap",
  //           lineWidth: 0.1,
  //         },
  //         tableLineColor: [0, 0, 0],
  //         didDrawPage: (data) => {
  //           const pageCountString = `Page ${
  //             data.pageNumber
  //           } of ${pdf.internal.getNumberOfPages()}`;
  //           const pageSize = pdf.internal.pageSize;
  //           const textWidth =
  //             (pdf.getStringUnitWidth(pageCountString) *
  //               pdf.internal.getFontSize()) /
  //             pdf.internal.scaleFactor;
  //           const x = (pageSize.width - textWidth) / 2;
  //           pdf.setFontSize(10);
  //           pdf.setTextColor(150);
  //           pdf.text(pageCountString, x, pageSize.height - 10);
  //         },
  //         didDrawCell: (data) => {
  //           const borderWidth = 0.2;
  //           const borderColor = "black";
  //           const cell = data.cell;
  //           const { x, y, width, height } = cell;

  //           pdf.setDrawColor(borderColor);
  //           pdf.setLineWidth(borderWidth);
  //           pdf.line(x, y, x + width, y);

  //           pdf.setDrawColor(borderColor);
  //           pdf.setLineWidth(borderWidth);
  //           pdf.line(x, y, x, y + height);

  //           pdf.setDrawColor(borderColor);
  //           pdf.setLineWidth(borderWidth);
  //           pdf.line(x, y + height, x + width, y + height);

  //           pdf.setDrawColor(borderColor);
  //           pdf.setLineWidth(borderWidth);
  //           pdf.line(x + width, y, x + width, y + height);
  //         },
  //       });
  //     // );
  //   } else {
  //     console.error('intNoWise is not an array.');
  //   }

  //   // Save the PDF
  //   pdf.save("your-file-name.pdf");
  // };

  // const genPdf=()=>{
  //   const doc = new jsPDF();

  // const intNoWise = listRecommendationReports?.interviewNumbers || [];

  // intNoWise.forEach((data, dindex) => {
  //   if (dindex > 0) {
  //     // Add a new page for each set of 20 data entries
  //     doc.addPage();
  //   }

  //   // Add headers
  //   doc.text(`Advertisement No. ${listRecommendationReports.advertisementNo}`, 10, 10);
  //   doc.text(listRecommendationReports.examName, 10, 20);
  //   doc.text('List of Sorting', 10, 30);

  //   // Create table headers
  //   const headers = ['SR No', 'Interview No'];

  //   // Create data for the table
  //   const tableData = data.map((item, index) => {
  //     const adjustedIndex = dindex * 20 + index + 1;

  //     return [adjustedIndex, item];
  //   });

  //   // Add the table to the PDF
  //   doc.autoTable({
  //     head: [headers],
  //     body: tableData,
  //     startY: 40,
  //   });

  //   // Add page numbers
  //   const pageCountString = `Page ${doc.internal.getNumberOfPages()}`;
  //   doc.setFontSize(10);
  //   doc.text(pageCountString, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10);
  // });

  // // Save the PDF
  // doc.save('your-file-name.pdf');
  // }

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      listRecommendationReports.examName +
      "</h5><h5>" +
      commonLabels.ListOfSorting +
      "</h5></div>";

    const htmlContent = document.createElement("div");
    // htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    // htmlContent.style.fontSize = "11.5px";
    var options = {};
    if (
      listRecommendationReports.recommendationReportType ==
      "recoCandidatesIntNo" ||
      listRecommendationReports.recommendationReportType ==
      "intNoWiseWithMeritNo"
    ) {
      htmlContent.style.fontSize = "10px";
      options = {
        margin: [0.95, 0.4, 0.68, 0.4],
        // filename: "Report_intInto_Wise_By_MPSC.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 3, dpi: 300, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
          compressPDF: true,
        },
      };
    } else if (
      listRecommendationReports?.recommendationReportType == "intNoWise"
    ) {
      htmlContent.style.fontSize = "6px";
      options = {
        margin: [1.12, 0.4, 0.0, 0.4],
        padding: [0, 0, 0, 0],
        // filename: "Report_intInto_Wise_By_MPSC.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 3, dpi: 300, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
          compressPDF: true,
        },
      };
    } else if (
      listRecommendationReports?.recommendationReportType == "VacantPosition"
    ) {
      htmlContent.style.fontSize = "10px";
      options = {
        margin: [1.5, 2.0, 0.0, 2.0],

        // filename: "Report_intInto_Wise_By_MPSC.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 3, dpi: 300, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
          compressPDF: true,
        },
      };
    } else if (
      listRecommendationReports.recommendationReportType ==
      "centerWiseRecoCandidates"
    ) {
      htmlContent.style.fontSize = "9px";
      options = {
        margin: [1.05, 0.4, 0.2, 0.4],
        // filename: "Report_intInto_Wise_By_MPSC.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 3, dpi: 300, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
          compressPDF: true,
        },
      };
    } else if (
      listRecommendationReports.recommendationReportType == "meritlist"
    ) {
      htmlContent.style.fontSize = "9px";
      options = {
        margin: [1.05, 0.4, 0.2, 0.4],
        // filename: "Report_intInto_Wise_By_MPSC.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 3, dpi: 300, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
          compressPDF: true,
        },
      };
    } else if (
      listRecommendationReports.recommendationReportType == "postwiserecolist"
    ) {
      htmlContent.style.fontSize = "9px";
      options = {
        margin: [1.05, 0.4, 0.2, 0.4],
        // filename: "Report_intInto_Wise_By_MPSC.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 3, dpi: 300, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
          compressPDF: true,
        },
      };
    }
    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;

          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          let dateX = pageWidth - dateWidth;
          if (i !== 1) {
            dateX = pageWidth - dateWidth - 0.4;
          }
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = listRecommendationReports.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);

          const headerText1 = label.MPSC;
          const headerX1 = pdf.internal.pageSize.width / 2;
          const headerY1 = 0.6;

          pdf.setFontSize(10);
          pdf.text(headerText1, headerX1, headerY1, { align: "center" });

          const headerText2 = listRecommendationReports.examName;
          const headerX2 = pdf.internal.pageSize.width / 2;
          const headerY2 = 0.8;

          pdf.setFontSize(10);
          pdf.text(headerText2, headerX2, headerY2, { align: "center" });

          if (
            listRecommendationReports?.recommendationReportType == "intNoWise"
          ) {
            const headerText3 = commonLabels.ListOfSorting;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }
          if (
            listRecommendationReports.recommendationReportType ==
            "recoCandidatesIntNo"
          ) {
            const headerText3 =
              commonLabels.RECOMMENDEDCANDIDATESINTERVIEWNUMBER;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }

          if (
            listRecommendationReports.recommendationReportType ==
            "centerWiseRecoCandidates"
          ) {
            const headerText3 = commonLabels.CENTREWISERECOMMENDEDCANDIDATES;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }

          if (
            listRecommendationReports.recommendationReportType ==
            "intNoWiseWithMeritNo"
          ) {
            const headerText3 = commonLabels.ListOfSorting;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }

          if (
            listRecommendationReports.recommendationReportType ==
            "VacantPosition"
          ) {
            const headerText3 = commonLabels.SEATMATRIXFORCHECKING;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }

          if (
            listRecommendationReports.recommendationReportType == "meritlist"
          ) {
            const headerText3 =
              commonLabels.Category_Subcategory_wise_Merit_List;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }
          if (
            listRecommendationReports.recommendationReportType ==
            "postwiserecolist"
          ) {
            const headerText3 =
              commonLabels.Category_Subcategory_wise_Merit_List;
            const headerX3 = pdf.internal.pageSize.width / 2;
            const headerY3 = 1.0;

            pdf.setFontSize(10);
            pdf.text(headerText3, headerX3, headerY3, { align: "center" });
          }

          const headerText4 =
            '<table className="table"><thead className="thead-light"><tr><th scope="col w-10">' +
            label.SRNo +
            '</th><th scope="col w-10">' +
            label.InterviewNo +
            '</th><th scope="col w-10">' +
            label.SRNo +
            '</th><th scope="col w-10">' +
            label.InterviewNo +
            '</th><th scope="col w-10">' +
            label.SRNo +
            '</th><th scope="col w-10">' +
            label.InterviewNo +
            '</th><th scope="col w-10">' +
            label.SRNo +
            '</th><th scope="col w-10">' +
            label.InterviewNo +
            '</th><th scope="col w-10">' +
            label.SRNo +
            '</th><th scope="col w-10">' +
            label.InterviewNo +
            "</th></tr></thead></table>";
          const headerX4 = 0.4;
          const headerY4 = 1.2;

          if (i !== 1) {
            //pdf.text(headerText4, headerX4, headerY4, { align: "center" });
          }
        }

        if (
          listRecommendationReports?.recommendationReportType == "intNoWise"
        ) {
          pdf.save(`Report_intInto_Wise_By_MPSC.pdf`);
        }
        if (
          listRecommendationReports.recommendationReportType ==
          "recoCandidatesIntNo"
        ) {
          pdf.save(`Report_recoCandidatesIntNo_By_MPSC.pdf`);
        }
        if (
          listRecommendationReports.recommendationReportType ==
          "intNoWiseWithMeritNo"
        ) {
          pdf.save(`Report_intNoWiseWithMeritNo_By_MPSC.pdf`);
        }
        if (
          listRecommendationReports.recommendationReportType ==
          "centerWiseRecoCandidates"
        ) {
          pdf.save(`Report_centerWiseRecoCandidates_By_MPSC.pdf`);
        }
        if (
          listRecommendationReports.recommendationReportType == "VacantPosition"
        ) {
          pdf.save(`VacantPosition.pdf`);
        }
        if (listRecommendationReports.recommendationReportType == "meritlist") {
          pdf.save(`Category_Subcategory_wise_Merit_List.pdf`);
        }
        if (
          listRecommendationReports.recommendationReportType ==
          "postwiserecolist"
        ) {
          pdf.save(`Post_Wise_Recommandation_List.pdf`);
        }
      });
    // html2pdf()
    //     .from(htmlContent)
    //     .set(options)
    //     .toPdf()
    //     .get('pdf')
    //     .then((pdf) => {
    //         const totalPages = pdf.internal.getNumberOfPages();

    //         for (let i = 1; i <= totalPages; i++) {
    //             pdf.setPage(i);

    //             const pageWidth = pdf.internal.pageSize.getWidth();
    //             const pageHeight = pdf.internal.pageSize.getHeight();
    //             const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
    //             const textX = pageWidth - textWidth - 1;
    //             const textY = 0.8;
    //             const currentDate = new Date();
    //             const formattedDate = currentDate.toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: '2-digit',
    //                 year: 'numeric',
    //             }).split('/').join('/');
    //             const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
    //             const dateX = pageWidth - dateWidth;
    //             const dateY = 0.6;
    //             pdf.setFontSize(8);
    //             pdf.text(formattedDate, dateX, dateY);
    //             pdf.text(`Page No. ${i}`, dateX, textY)

    //             const ad = listRecommendationReports.advertisementNo;
    //             const headerText = `Advertisement No. ${ad}`;
    //             const headerX = 0.4;
    //             const headerY = 0.6;

    //             pdf.setFontSize(8);
    //             pdf.text(headerText, headerX, headerY);
    //         }

    //         pdf.save(`'Report_intInto_Wise_By_MPSC.pdf`);

    //     });
  };

  useEffect(() => {
    if (listRecommendationReports?.interviewNumbers) {
      const intNoWise = listRecommendationReports?.interviewNumbers || [];
      let i = 0;
      let finalTableData = "";
      let tableData = "";
      intNoWise.forEach((data, dindex) => {
        tableData =
          '<table class="table tableData no-page-break id="table_with_data"><thead class="thead-light "><tr><th scope="col w-10 text-center">' +
          label.SRNo +
          '</th><th scope="col w-10">' +
          label.IntNo +
          "</th></tr></thead><tbody>";

        data.length > 0 &&
          data.forEach((item, index) => {
            const adjustedIndex = dindex * 40 + index + 1;
            tableData +=
              "<tr><td text-center>" +
              adjustedIndex +
              "</td><td>" +
              item +
              "</td></tr>";
          });

        tableData += "</tbody></table>";

        finalTableData += tableData;
      });

      setintNoWise(finalTableData);
    }
    if (listRecommendationReports?.interviewNumbers) {
    }
  }, [listRecommendationReports]);

  useEffect(() => {
    const intNoWise = listRecommendationReports?.qualifiedCandidates || [];
    let i = 0;
    let finalTableData = "";
    let tableData = "";
    tableData =
      '<table class="table  no-page-break id="table_with_data"><thead class="thead-light "><tr><th scope="col w-10 text-center">' +
      label.SRNo +
      '</th><th  scope="col w-10">' +
      label.IntNo +
      '</th><th  scope="col w-10">' +
      label.CandidateName +
      '</th><th scope="col w-10">' +
      label.Category +
      '</th><th  scope="col w-10">' +
      label.SubCategory +
      '</th><th scope="col w-10">' +
      label.PostCriteria +
      '</th><th scope="col w-10">' +
      label.Status +
      "</th></tr></thead><tbody>";
    intNoWise.forEach((data, dindex) => {
      // data.length > 0 &&
      //   data.forEach((item, index) => {
      // const adjustedIndex = dindex * 40 + index + 1;
      tableData +=
        "<tr><td text-center>" +
        dindex +
        "</td><td >" +
        data.interviewNo +
        "</td> <td >" +
        data.candidateName +
        "</td><td>" +
        data.category +
        "</td><td>" +
        data.subCategory +
        "</td><td>" +
        data.postCriteriaName +
        "</td><td>" +
        data.status +
        "</td></tr>";
      // });
    });
    tableData += "</tbody></table>";

    finalTableData += tableData;
    setMeritListData(finalTableData);
  }, [listRecommendationReports]);

  useEffect(() => {
    const intNoWise = listRecommendationReports?.postWiseRecoList || [];
    let i = 0;
    let finalTableData = "";
    let tableData = "";
    intNoWise.map((category, index) => {
      tableData +=
        '<table class="table  no-page-break id="table_with_data">' +
        "<h5>" +
        category.postCriteriaName +
        "</h5>" +
        '<thead class="thead-light "><tr><th class="text-center" scope="col w-10">' +
        label.SRNo +
        '</th><th  scope="col w-10">' +
        label.IntNo +
        '</th><th scope="col w-10">' +
        label.CandidateName +
        '</th><th scope="col w-10">' +
        label.Category +
        '</th><th scope="col w-10">' +
        label.SubCategory +
        '</th><th scope="col w-10">' +
        label.PostCriteria +
        '</th><th scope="col w-10">' +
        label.Status +
        "</th></tr></thead><tbody>";
      category.recommendedCandidates.length > 0 &&
        category.recommendedCandidates.map((data, dindex) => {
          tableData +=
            "<tr><td text-center>" +
            dindex +
            "</td><td >" +
            data.interviewNo +
            "</td> <td >" +
            data.candidateName +
            "</td><td>" +
            data.category +
            "</td><td>" +
            data.subCategory +
            "</td><td>" +
            data.postCriteriaName +
            "</td><td>" +
            data.status +
            "</td></tr>";
        });
    });

    // intNoWise.forEach((data, dindex) => {

    //   tableData =
    //   '<table class="table  no-page-break id="table_with_data"><thead class="thead-light "><tr><th scope="col w-10">' +
    //   label.SRNo +
    //   '</th><th class="text-center" scope="col w-10">' +
    //   label.IntNo +
    //   '</th><th class="text-center" scope="col w-10">' +
    //   label.CandidateName +
    //   '</th><th class="text-center" scope="col w-10">' +
    //   label.Category +
    //   '</th><th class="text-center" scope="col w-10">' +
    //   label.SubCategory +
    //   '</th><th class="text-center" scope="col w-10">' +
    //   label.PostCriteria +
    //   '</th><th class="text-center" scope="col w-10">' +
    //   label.Status +
    //   "</th></tr></thead><tbody>";
    //   data.recommendedCandidates.length > 0 &&
    //     data.recommendedCandidates.forEach((item, index) => {
    //       const adjustedIndex = dindex * 40 + index + 1;
    //       tableData +=
    //         "<tr><td text-center>" + dindex + "</td><td >" + item.interviewNo + "</td> <td >" + item.candidateName + "</td><td>" + item.category + "</td><td>" + item.subCategory + "</td><td>" + item.postCriteriaName + "</td><td>" + item.status + "</td></tr>";
    //     });

    // });
    tableData += "</tbody></table>";

    finalTableData += tableData;
    setPostWiseRecData(finalTableData);
  }, [listRecommendationReports]);

  useEffect(() => {
    const recoCandidatesIntNo =
      listRecommendationReports?.recoCandidatesIntNo || [];
    let i = 0;
    let tableData = "";
    recoCandidatesIntNo.forEach((item, index) => {
      i = 0;
      tableData +=
        '<div class="postData html2pdf__page-break"><label class="font-weight-bold text-center mb-2 font-size-10">' +
        item.postName +
        '</label><table class="table tableData no-page-break"><thead class="thead-light"><tr><th scope="col w-10 class="text-center"">' +
        label.SRNo +
        '</th><th scope="col w-10">' +
        label.MeritNo +
        '</th><th scope="col w-10">' +
        label.IntNo +
        "</th></tr></thead><tbody>";
      {
        item.recommendedCandidates &&
          item.recommendedCandidates?.length > 0 &&
          item.recommendedCandidates.map((item1, index1) => {
            if (i == 35) {
              i = 0;
              tableData +=
                '</tbody></table><table class="table tableData no-page-break"><thead class="thead-light"><tr><th scope="col w-10 class=text-center">' +
                label.SRNo +
                '</th><th scope="col w-10">' +
                label.MeritNo +
                '</th><th scope="col w-10">' +
                label.IntNo +
                "</th></tr></thead><tbody><tr><td class='text-center'>" +
                (index1 + 1) +
                "</td><td>" +
                item.recommendedCandidates[index1].meritNo +
                "</td><td>" +
                item.recommendedCandidates[index1].interviewNo +
                "</td></tr>";
              i = i + 1;
            } else {
              tableData +=
                "<tr><td class='text-center'>" +
                (index1 + 1) +
                "</td><td>" +
                item.recommendedCandidates[index1].meritNo +
                "</td><td>" +
                item.recommendedCandidates[index1].interviewNo +
                "</td></tr>";
              i = i + 1;
            }
          });
      }

      tableData += "</tbody></table></div>";
    });

    setgetrecoCandidatesIntNo(tableData);
  }, [listRecommendationReports]);

  useEffect(() => {
    const intNoWiseWithMeritNo =
      listRecommendationReports?.intNoWiseWithMeritNo || [];
    let i = 0;
    let tableData = "";
    intNoWiseWithMeritNo.forEach((item, index) => {
      i = 0;
      tableData +=
        '<div class="postData html2pdf__page-break"><label class="font-weight-bold text-center mb-2">' +
        item.postName +
        '</label><table class="table tableData no-page-break"><thead class="thead-light"><tr><th scope="col w-10 class=text-center">' +
        label.SRNo +
        '</th><th scope="col w-10">' +
        label.MeritNo +
        '</th><th scope="col w-10">' +
        label.IntNo +
        "</th></tr></thead><tbody>";
      {
        item.recommendedCandidates &&
          item.recommendedCandidates?.length > 0 &&
          item.recommendedCandidates.map((item1, index1) => {
            if (i == 20) {
              i = 0;
              tableData +=
                '</tbody></table><table class="table tableData no-page-break"><thead class="thead-light"><tr><th scope="col w-10 class=text-center">' +
                label.SRNo +
                '</th><th scope="col w-10">' +
                label.MeritNo +
                '</th><th scope="col w-10">' +
                label.IntNo +
                "</th></tr></thead><tbody><tr><td class='text-center'>" +
                (index1 + 1) +
                "</td><td>" +
                item.recommendedCandidates[index1].meritNo +
                "</td><td>" +
                item.recommendedCandidates[index1].interviewNo +
                "</td></tr>";
              i = i + 1;
            } else {
              tableData +=
                "<tr><td class='text-center'>" +
                (index1 + 1) +
                "</td><td>" +
                item.recommendedCandidates[index1].meritNo +
                "</td><td>" +
                item.recommendedCandidates[index1].interviewNo +
                "</td></tr>";
              i = i + 1;
            }
          });
      }

      tableData += "</tbody></table></div>";
    });

    setintNoWiseWithMeritNo(tableData);
  }, [listRecommendationReports]);

  useEffect(() => {
    const centerWiseRecoCandidates =
      listRecommendationReports?.centerWiseRecoCandidates || [];

    let tableData = "";

    centerWiseRecoCandidates.forEach((centerData, index) => {
      tableData +=
        '<div class="postData "><label class="font-weight-bold ">' +
        label.CenterName +
        ":" +
        " " +
        centerData.centerName +
        "</label>";

      centerData.data.forEach((subCenterData, subCenterIndex) => {
        tableData +=
          '<div class="postData html2pdf__page-break"><label class="font-weight-bold mb-2">' +
          label.subCenterName +
          ":" +
          " " +
          subCenterData.subCenterName +
          "</label><table class='table tableData no-page-break ' style='width:50%'><thead class='thead-light'><tr><th scope='col w-10 class=text-center'>" +
          label.SRNo +
          "</th><th scope='col w-10'>" +
          label.RollNo +
          "</th><th scope='col w-10'>" +
          label.CandidateName +
          "</th></tr></thead><tbody>";
        let i = 0;
        subCenterData.recommendedCandidates.forEach(
          (candidate, candidateIndex) => {
            if (i == 12) {
              i = 0;
              tableData +=
                "</tbody></table><table class='table tableData no-page-break ' style='width:50%'><thead class='thead-light'><tr><th scope='col w-10 class=text-center'>" +
                label.SRNo +
                "</th><th scope='col w-10'>" +
                label.RollNo +
                "</th><th scope='col w-10'>" +
                label.CandidateName +
                "</th></tr></thead><tbody><tr><td class=text-center>" +
                (candidateIndex + 1) +
                "</td><td>" +
                candidate.rollNo +
                "</td><td>" +
                candidate.candidateName +
                "</td></tr>";
              i = i + 1;
            } else {
              tableData +=
                "<tr><td class=text-center>" +
                (candidateIndex + 1) +
                "</td><td>" +
                candidate.rollNo +
                "</td><td>" +
                candidate.candidateName +
                "</td></tr>";
              i = i + 1;
            }
          }
        );

        tableData += "</tbody></table>";
        tableData +=
          '<label class="font-weight-bold">' +
          label.CenterCount +
          ":" +
          " " +
          centerData.centerCount +
          "</label></div>";
      });

      tableData += "</div>";
    });

    setCenterWiseRecoCandidates(tableData);
  }, [listRecommendationReports]);

  // useEffect(() => {
  //   const intNoWise = listRecommendationReports?.interviewNumbers || [];
  //   let finalTableData = "";

  //   intNoWise.forEach((data, dindex) => {
  //     let chunks = [];
  //     for (let i = 0; i < data.length; i += 22) {
  //       chunks.push(data.slice(i, i + 22));
  //     }

  //     chunks.forEach((chunk, cindex) => {
  //       let tableData =
  //         '<table class="table tableData no-page-break"><thead class="thead-light"><tr><th scope="col">' +
  //         label.SRNo +
  //         '</th><th scope="col">' +
  //         label.IntNo +
  //         "</th></tr></thead><tbody>";

  //       chunk.forEach((item, index) => {
  //         const adjustedIndex = dindex * 22 + cindex * 22 + index + 1;
  //         tableData +=
  //           "<tr><td>" + adjustedIndex + "</td><td>" + item + "</td></tr>";
  //       });

  //       tableData += "</tbody></table>";
  //       finalTableData += tableData;
  //     });
  //   });

  //   setintNoWise(finalTableData);
  // }, [listRecommendationReports]);

  return (
    <div className="dashboardContentArea">
      <h5> {label.RecommendationReports} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                        // <option key={index} value={element.id}>
                        //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                        // </option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    {commonLabels.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    {commonLabels.ReportsType}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="listreport"
                    disabled={selectedExam === ""}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onListReport(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {listing &&
                      listing.length > 0 &&
                      listing
                        // .filter(
                        //   (element) =>
                        //     element.isDeleted === false &&
                        //     element.isActive === true
                        // )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("listreport.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              {selectedlist !== "" &&
                selectedlist !== "2" &&
                selectedlist !== "1" && (
                  <div className="row">
                    <div className="form-group col-md-3">
                      <label className="float-left">
                        {commonLabels.reportRequiredbyMpsc}
                        <span className="errorText">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="reportByMPSC"
                        ref={register({ required: true })}
                        onChange={(e) => {
                          onReportByMPSC(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {reportbyMPSClisting &&
                          reportbyMPSClisting.length > 0 &&
                          reportbyMPSClisting.map((element, index) => (
                            <option key={index + 1} value={element.name}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                      {_.get("reportByMPSC.type", errors) === "required" && (
                        <p className="errorText float-left">
                          {commonLabels.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </form>
        </div>
      </div>

      {(session.roleName == "superadmin" ||
        session.roleName == "desk officer") && (
          <div className="row ">
            <div className="col-md-12 mb-2">
              {selectedlist !== "2" && selectedlist !== "1" && (
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                  disabled={saveButtonFlag}
                  onClick={handleSubmit((e) => {
                    onSubmit(e);
                    setConfirmClicked(true);
                  })}
                >
                  {commonLabels.BUTTON_VIEW}
                </button>
              )}
              <button
                type="button"
                disabled={printFlag}
                className="btn btn-primary"
                onClick={() => {
                  printQualifyingListPDF();
                }}
              >
                {commonLabels.BUTTON_PRINT}
              </button>
            </div>
          </div>
        )}
      {listRecommendationReports &&
        listRecommendationReports?.recommendationReportType == "intNoWise" &&
        listRecommendationReports.interviewNumbers &&
        listRecommendationReports.interviewNumbers.length > 0 && (
          <div ref={pdfRef} id="qualifyingCandidatesList">
            <div className="row ">
              <div className="col-md-12">
                <div dangerouslySetInnerHTML={{ __html: intNoWise }} />
              </div>
            </div>
          </div>
        )}

      {listRecommendationReports &&
        listRecommendationReports.recommendationReportType ==
        "recoCandidatesIntNo" &&
        listRecommendationReports.recoCandidatesIntNo &&
        listRecommendationReports.recoCandidatesIntNo.length > 0 && (
          <div ref={pdfRef} id="qualifyingCandidatesList ">
            <div className="row ">
              <div className="col-md-12 mt-3 ">
                <div
                  dangerouslySetInnerHTML={{ __html: getrecoCandidatesIntNo }}
                />
              </div>
            </div>
          </div>
        )}

      {listRecommendationReports &&
        listRecommendationReports.recommendationReportType ==
        "centerWiseRecoCandidates" &&
        listRecommendationReports.centerWiseRecoCandidates &&
        listRecommendationReports.centerWiseRecoCandidates.length > 0 && (
          <div ref={pdfRef} id="qualifyingCandidatesList">
            <div className="row ">
              <div className="col-md-12 mt-3 ">
                <div
                  dangerouslySetInnerHTML={{ __html: centerWiseRecoCandidates }}
                />
              </div>
            </div>
          </div>
        )}

      {listRecommendationReports &&
        listRecommendationReports.recommendationReportType ==
        "intNoWiseWithMeritNo" &&
        listRecommendationReports.intNoWiseWithMeritNo &&
        listRecommendationReports.intNoWiseWithMeritNo.length > 0 && (
          <div ref={pdfRef} id="qualifyingCandidatesList">
            <div className="row ">
              <div className="col-md-12 mt-3 ">
                <div
                  dangerouslySetInnerHTML={{ __html: intNoWiseWithMeritNo }}
                />
              </div>
            </div>
          </div>
        )}
      {listRecommendationReports &&
        listRecommendationReports.recommendationReportType == "meritlist" &&
        listRecommendationReports.qualifiedCandidates &&
        listRecommendationReports.qualifiedCandidates.length > 0 && (
          <div ref={pdfRef} id="meritList">
            <div className="row ">
              <div className="col-md-12 mt-3 ">
                <div dangerouslySetInnerHTML={{ __html: meritListData }} />
              </div>
            </div>
          </div>
        )}
      {listRecommendationReports &&
        listRecommendationReports.recommendationReportType ==
        "postwiserecolist" &&
        listRecommendationReports.postWiseRecoList &&
        listRecommendationReports.postWiseRecoList.length > 0 && (
          <div ref={pdfRef} id="postwiserecolist">
            <div className="row ">
              <div className="col-md-12 mt-3 ">
                <div dangerouslySetInnerHTML={{ __html: postWiseRecData }} />
              </div>
            </div>
          </div>
        )}

      {listRecommendationReports &&
        listRecommendationReports.recommendationReportType ===
        "VacantPosition" &&
        listRecommendationReports.vacantPosition &&
        listRecommendationReports.vacantPosition.length > 0 && (
          <div
            ref={pdfRef}
            id="qualifyingCandidatesList"
            className="container mt-4"
          >
            {listRecommendationReports.vacantPosition.map((item, index) => (
              <div className="row justify-content-center" key={index}>
                <div className="col-md-12 ">
                  <table
                    className="table table-bordered text-center bold-label no-page-break"
                    cellPadding={0.5}
                  >
                    <thead className="bold-label">
                      <tr>
                        <th></th>
                        <th className="text-right pr-5">{label.Posts}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{item.code}</td>
                        <td>
                          <table
                            className="table table-border bold-label"
                            cellPadding={0.5}
                          >
                            <tbody>
                              {item.data.map(
                                (codeCategory, codeCategoryIndex) => (
                                  <tr key={codeCategoryIndex}>
                                    <td>{codeCategory.categoryName}</td>
                                    <td>
                                      <table
                                        className="table table-borderless bold-label"
                                        cellPadding={0.5}
                                      >
                                        <tbody>
                                          {codeCategory.data.map(
                                            (subcategory, subCategoryIndex) => (
                                              <tr key={subCategoryIndex}>
                                                <td>
                                                  {subcategory.subCategoryName}
                                                </td>
                                                <td>{subcategory.posts}</td>
                                              </tr>
                                            )
                                          )}
                                          <tr>
                                            <td>Category Total</td>{" "}
                                            <td>
                                              {codeCategory.categoryTotal}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                )
                              )}
                              <tr>
                                <td>Post Total</td>
                                <td>{item.postTotal}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* <div  className="table table-bordered text-center bold-label">
                <div className="bold-label">
                    <tr>
                      <th></th>
                      <th className="text-right pr-5">{label.Posts}</th>
                    </tr>
                  </div>
                </div> */}
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default RecommendationReports;
